"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var antd_1 = require("antd");
var reconnect_js_1 = require("reconnect.js");
var Algorithm = __importStar(require("../../Utils/VariantsUtil"));
var index_1 = require("../../index");
var InputCounter_1 = __importDefault(require("../InputCounter"));
var VARIANTS_DISPLAY_TYPE;
(function (VARIANTS_DISPLAY_TYPE) {
  VARIANTS_DISPLAY_TYPE["radio"] = "radio";
  VARIANTS_DISPLAY_TYPE["select"] = "select";
})(VARIANTS_DISPLAY_TYPE || (VARIANTS_DISPLAY_TYPE = {}));
function calcOriginalPrice(_a) {
  var amount = _a.amount,
    price = _a.price,
    originalPrice = _a.originalPrice;
  if (!originalPrice) {
    return amount;
  } else if (!price) {
    return amount;
  }
  var f = amount / price;
  return Math.round(originalPrice * f);
}
function ProductVariants(props) {
  var _this = this;
  var actions = reconnect_js_1.useOutlet('actions')[0];
  var product = props.product,
    onNextConfig = props.onNextConfig,
    _a = props.config,
    config = _a === void 0 ? null : _a,
    _b = props.disabled,
    disabled = _b === void 0 ? false : _b,
    _c = props.rowStyle,
    rowStyle = _c === void 0 ? {} : _c,
    onCartItemConfigChange = props.onCartItemConfigChange;
  var initQuantity = react_1.useMemo(function () {
    return (config === null || config === void 0 ? void 0 : config.qty) || 1;
  }, [config === null || config === void 0 ? void 0 : config.qty]);
  var _d = react_1.default.useState(initQuantity),
    quantity = _d[0],
    setQuantity = _d[1];
  var initValues = react_1.useMemo(function () {
    return (config === null || config === void 0 ? void 0 : config.variants) || (product.variants || []).reduce(function (acc, variant) {
      if (variant.type === 'single' && Array.isArray(variant.choices) && variant.choices[0]) {
        acc.push({
          name: variant.name,
          choice: variant.choices[0].name
        });
      }
      return acc;
    }, []);
  }, [config === null || config === void 0 ? void 0 : config.variants, product.variants]);
  var _e = react_1.default.useState(initValues),
    values = _e[0],
    setValues = _e[1];
  var fetchData = react_1.useCallback(function (_a) {
    var quantity = _a.quantity,
      values = _a.values;
    return __awaiter(_this, void 0, void 0, function () {
      var itemConfig, resp, extra, ex_1;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            if (!onNextConfig) return [3 /*break*/, 5];
            _b.label = 1;
          case 1:
            _b.trys.push([1, 3, 4, 5]);
            actions.setLoading(true);
            itemConfig = {
              qty: quantity,
              variants: values
            };
            return [4 /*yield*/, index_1.Cart.calcPrice(product.id, itemConfig)];
          case 2:
            resp = _b.sent();
            extra = {
              original_price: calcOriginalPrice({
                amount: resp.amount,
                price: product.price,
                originalPrice: product.original_price
              })
            };
            onNextConfig(itemConfig, resp, extra);
            return [3 /*break*/, 5];
          case 3:
            ex_1 = _b.sent();
            console.warn(ex_1);
            return [3 /*break*/, 5];
          case 4:
            actions.setLoading(false);
            return [7 /*endfinally*/];
          case 5:
            return [2 /*return*/];
        }
      });
    });
  }, [actions, onNextConfig, product.id, product.original_price, product.price]);
  react_1.useEffect(function () {
    fetchData({
      quantity: initQuantity,
      values: initValues
    });
  }, [fetchData, initQuantity, initValues]);
  function onConfigChange(quantity, values) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!(typeof onCartItemConfigChange === 'function')) return [3 /*break*/, 1];
            // we're in Cart
            onCartItemConfigChange({
              qty: quantity,
              variants: values
            });
            return [3 /*break*/, 3];
          case 1:
            // we're in Product Detail
            return [4 /*yield*/, fetchData({
              quantity: quantity,
              values: values
            })];
          case 2:
            // we're in Product Detail
            _a.sent();
            _a.label = 3;
          case 3:
            return [2 /*return*/];
        }
      });
    });
  }

  return react_1.default.createElement(Wrapper, null, (product.variants || []).map(function (variant) {
    if (variant.type === 'bool') {
      return react_1.default.createElement(InputField, {
        key: variant.name,
        style: rowStyle
      }, react_1.default.createElement(antd_1.Checkbox, {
        disabled: disabled,
        checked: Algorithm.getBool({
          values: values,
          name: variant.name
        }),
        onChange: function onChange(evt) {
          return __awaiter(_this, void 0, void 0, function () {
            var nextValues;
            return __generator(this, function (_a) {
              switch (_a.label) {
                case 0:
                  nextValues = Algorithm.setBool({
                    values: values,
                    setValues: setValues,
                    name: variant.name,
                    checked: evt.target.checked
                  });
                  return [4 /*yield*/, onConfigChange(quantity, nextValues)];
                case 1:
                  _a.sent();
                  return [2 /*return*/];
              }
            });
          });
        }
      }, variant.label));
    } else if (variant.type === 'single') {
      return react_1.default.createElement(InputField, {
        key: variant.name,
        style: rowStyle
      }, react_1.default.createElement("label", null, variant.label), variant.displayType === VARIANTS_DISPLAY_TYPE.radio ? react_1.default.createElement(StyleRadioGroup, {
        disabled: disabled,
        value: Algorithm.getSingle({
          values: values,
          name: variant.name
        }),
        buttonStyle: "solid",
        onChange: function onChange(e) {
          return __awaiter(_this, void 0, void 0, function () {
            var value, nextValues;
            return __generator(this, function (_a) {
              switch (_a.label) {
                case 0:
                  value = e.target.value;
                  nextValues = Algorithm.setSingle({
                    values: values,
                    setValues: setValues,
                    name: variant.name,
                    choice: value
                  });
                  return [4 /*yield*/, onConfigChange(quantity, nextValues)];
                case 1:
                  _a.sent();
                  return [2 /*return*/];
              }
            });
          });
        }
      }, (variant.choices || []).map(function (option) {
        return react_1.default.createElement(antd_1.Radio.Button, {
          className: "radio-btn",
          key: option.name,
          value: option.name
        }, option.label);
      })) : react_1.default.createElement(antd_1.Select, {
        disabled: disabled,
        style: {
          width: '100%'
        },
        value: Algorithm.getSingle({
          values: values,
          name: variant.name
        }),
        onChange: function onChange(value) {
          return __awaiter(_this, void 0, void 0, function () {
            var nextValues;
            return __generator(this, function (_a) {
              switch (_a.label) {
                case 0:
                  nextValues = Algorithm.setSingle({
                    values: values,
                    setValues: setValues,
                    name: variant.name,
                    choice: value
                  });
                  return [4 /*yield*/, onConfigChange(quantity, nextValues)];
                case 1:
                  _a.sent();
                  return [2 /*return*/];
              }
            });
          });
        }
      }, (variant.choices || []).map(function (option) {
        return react_1.default.createElement(antd_1.Select.Option, {
          key: option.name,
          value: option.name
        }, option.label);
      })));
    }
    return null;
  }), react_1.default.createElement(InputField, {
    style: rowStyle,
    className: "product-quantity"
  }, react_1.default.createElement("label", null, actions.L('order_quantity')), disabled ? react_1.default.createElement("div", null, "x ", quantity) : react_1.default.createElement(InputCounter_1.default, {
    step: 1,
    value: quantity,
    onChange: function onChange(_value) {
      return setQuantity(_value);
    },
    callback: function callback(_value) {
      return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4 /*yield*/, onConfigChange(_value, values)];
            case 1:
              _a.sent();
              return [2 /*return*/];
          }
        });
      });
    },

    inputProps: {
      min: 1,
      disabled: disabled
    }
  })));
}
var StyleRadioGroup = styled_components_1.default(antd_1.Radio.Group)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  --btn-gutter: 5px;\n  width: 100%;\n  display: flex !important;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  & > .radio-btn {\n    margin-bottom: var(--btn-gutter);\n    border-radius: 0 !important;\n  }\n"], ["\n  --btn-gutter: 5px;\n  width: 100%;\n  display: flex !important;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  & > .radio-btn {\n    margin-bottom: var(--btn-gutter);\n    border-radius: 0 !important;\n  }\n"])));
var Wrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n"])));
var InputField = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-bottom: 10px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  width: 100%;\n  max-width: 260px;\n  & > label {\n    margin: 5px 0;\n    white-space: nowrap;\n  }\n"], ["\n  margin-bottom: 10px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  width: 100%;\n  max-width: 260px;\n  & > label {\n    margin: 5px 0;\n    white-space: nowrap;\n  }\n"])));
exports.default = ProductVariants;
var templateObject_1, templateObject_2, templateObject_3;